import { Prize, PrizeType } from '../types';

/**
 * Renders prize display text based on prize type
 */
export function renderPrizeText(prize: Prize): string {
  if (!prize.type) {
    return prize.name;
  }

  const prizeType = typeof prize.type === 'string' ? prize.type.toUpperCase() : prize.type;

  switch (prizeType) {
    case PrizeType.KARMA:
    case 'KARMA':
      return `${prize.value} Karma`;

    case PrizeType.FREE_SPIN:
    case 'FREE_SPIN':
      return 'Free Spin';

    case PrizeType.ALPHA_NFT:
    case 'ALPHA_NFT':
      return `Alpha NFT: ${prize.name}`;

    case PrizeType.NFT:
    case 'NFT':
      return `NFT: ${prize.name}`;

    case PrizeType.USDT:
    case 'USDT':
    case PrizeType.TOKEN:
    case 'TOKEN':
      const symbol = prize.tokenConfig?.symbol || 'tokens';
      return `${prize.value} ${symbol}`;

    default:
      return prize.name;
  }
}

/**
 * Gets color category based on prize type and category
 */
export function getPrizeColor(prize: Prize): string {
  // Priority: use category if available
  if (prize.category) {
    const category = typeof prize.category === 'string' ? prize.category.toLowerCase() : prize.category;
    switch (category) {
      case 'legendary':
        return '#FF70A6'; // Pink
      case 'rare':
        return '#C084FC'; // Purple
      case 'common':
      default:
        return '#2A9D8F'; // Teal
    }
  }

  // Fallback to type-based colors
  if (prize.type) {
    const prizeType = typeof prize.type === 'string' ? prize.type.toUpperCase() : prize.type;
    switch (prizeType) {
      case PrizeType.KARMA:
      case 'KARMA':
        return '#5FC9F8'; // Blue
      case PrizeType.FREE_SPIN:
      case 'FREE_SPIN':
        return '#FF70A6'; // Pink
      case PrizeType.ALPHA_NFT:
      case 'ALPHA_NFT':
        return '#C084FC'; // Purple
      case PrizeType.NFT:
      case 'NFT':
        return '#82A0FF'; // Light blue
      case PrizeType.USDT:
      case 'USDT':
      case PrizeType.TOKEN:
      case 'TOKEN':
        return '#2A9D8F'; // Teal
      default:
        return '#2A9D8F';
    }
  }

  return '#2A9D8F'; // Default teal
}
